import React from "react";
import { Button, Col, Row } from "reactstrap";
import { PARTNER_MEMB_INACTIVE_STATUS } from "../../../../../utils/constants";
import { handleRequestError } from "../../../../../utils/helpers";
import { updatePartnerMembershipStatus } from "../../../../actions/partners";
import ConfirmModal from "../../../common/confirmModal/confirmModal";

interface Partner {
  idMembresiaSocio: string;
  idPersona: string;
  idPropietario: string;
}

interface Props {
  partner: Partner;
  reload: () => any;
}

class InactivarMembresia extends React.Component<Props> {
  state = {
    isOpen: false,
    waiting: false
  };

  executeInactivateMembership = () => {
    const { idMembresiaSocio: membresiaSocioId } = this.props.partner;

    this.setState({ waiting: true });

    updatePartnerMembershipStatus(
      membresiaSocioId,
      PARTNER_MEMB_INACTIVE_STATUS
    )
      .then(() => {
        this.setState({ waiting: false, isOpen: false });
        this.props.reload();
      })
      .catch((err: any) => {
        this.setState({ waiting: false });
        handleRequestError(err);
      });
  };

  clearState = () => {
    this.setState({
      isOpen: false,
      waiting: false
    });
  };

  render() {
    return (
      <div>
        <ConfirmModal
          title="Inactivar"
          message="Se inactivará la membresía socio para reiniciar el proceso de REACTIVACION.  ¿Desea continuar?"
          isOpen={this.state.isOpen}
          size="md"
          waiting={!!this.state.waiting}
          ok={() => {
            this.executeInactivateMembership();
          }}
          cancel={() => {
            this.setState({
              isOpen: false,
              waiting: false
            });
          }}
        />

        <Row className="p-0 m-0">
          <Col xs={4}>
            <Button
              block
              onClick={() => {
                this.setState({ isOpen: true });
              }}
              className="mt-3"
            >
              Inactivar membresía
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default InactivarMembresia;
